<template>
  <div>
    <div
      v-if="showFooter"
      class="footer mt-3"
      :class="isMobile ? 'footer-sm' : 'footer-lg'"
    >
      <div class="align-items-center justify-content-lg-between">
        <div class="col-lg-12 text-center">
          <ul class="nav nav-footer footer-nav-row justify-content-between">
            <li
              class="nav-item"
              :class="{ 'is-active': linkIsActive('/home') }"
              @click="$router.push('/home')"
            >
              <div class="d-flex flex-column banking-icons">
                <span class="footer-nav-icon-wrap">
                  <i class="fas fa-home footer-nav-ico" aria-hidden="true"></i>
                </span>
                <div class="mx-auto pt-1 text-sm footer-text">
                  {{ $t('footer.home') }}
                </div>
              </div>
            </li>

            <li
              class="nav-item"
              :class="{ 'is-active': linkIsActive('/promotion') }"
              @click="$router.push('/promotion')"
            >
              <div class="d-flex flex-column banking-icons">
                <span class="footer-nav-icon-wrap">
                  <i class="fas fa-tags footer-nav-ico" aria-hidden="true"></i>
                </span>
                <div class="mx-auto pt-1 text-sm footer-text">
                  {{ $t('footer.promotion') }}
                </div>
              </div>
            </li>

            <li
              class="nav-item"
              :class="{ 'is-active': linkIsActive('/withdraw') }"
              @click="$router.push('/withdraw')"
            >
              <div class="d-flex flex-column banking-icons">
                <span class="footer-nav-icon-wrap">
                  <i class="fas fa-hand-holding-dollar footer-nav-ico" aria-hidden="true"></i>
                </span>
                <div class="mx-auto pt-1 text-sm footer-text">
                  {{ $t('footer.withdraw') }}
                </div>
              </div>
            </li>

            <li
              class="nav-item"
              :class="{ 'is-active': linkIsActive('/deposit') }"
              @click="$router.push('/deposit')"
            >
              <div class="d-flex flex-column banking-icons">
                <span class="footer-nav-icon-wrap">
                  <i class="fas fa-wallet footer-nav-ico" aria-hidden="true"></i>
                </span>
                <div class="mx-auto pt-1 text-sm footer-text">
                  {{ $t('setting.deposit') }}
                </div>
              </div>
            </li>

            <li
              class="nav-item"
              :class="{ 'is-active': linkIsActive('/setting') }"
              @click="$router.push('/setting')"
            >
              <div class="d-flex flex-column banking-icons">
                <span class="footer-nav-icon-wrap">
                  <i class="fas fa-user footer-nav-ico" aria-hidden="true"></i>
                </span>
                <div class="mx-auto pt-1 text-sm footer-text">
                  {{ $t('footer.profile') }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_live: false,
      isMobile: false,
    };
  },
  computed: {
    showFooter() {
      const p = this.$route.path;
      return p !== '/maung-fb' && p !== '/body-fb';
    },
  },
  methods: {
    closeModal() {
      $('#download-modal').modal('hide');
    },
    openModal() {
      $('#download-modal').modal('show');
    },
    linkIsActive(link) {
      return this.$route.path === link;
    },
    updateIsMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    async fetchFootballLive() {
      try {
        const res = await axios.get('/football-lives');
        this.is_live = res.data.data[0].is_live;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.updateIsMobile();
    window.addEventListener('resize', this.updateIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateIsMobile);
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background: #1a1a1a;
  border-top: 1px solid #333;
  padding: 0.5rem 0;
}

.footer-sm {
  padding: 0.25rem 0;
}

.footer-lg {
  padding: 0.75rem 0;
}

.nav-footer {
  margin: 0;
  padding: 0 0.35rem;
}

.footer-nav-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  list-style: none;
  padding: 0 0.25rem;
}

.footer-nav-row .nav-item {
  flex: 1 1 0;
  min-width: 0;
  max-width: 20%;
}

.banking-icons {
  cursor: pointer;
}

.footer-nav-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  margin: 0 auto;
}

.footer-nav-ico {
  font-size: 1.2rem;
  line-height: 1;
  color: #8f8d94;
  transition: color 0.15s ease, transform 0.12s ease;
}

.footer-nav-row .nav-item:active .footer-nav-ico {
  transform: scale(0.92);
}

.footer-text {
  font-size: 0.68rem;
  color: #adacb1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: color 0.15s ease;
}

.footer-nav-row .nav-item.is-active .footer-nav-ico,
.footer-nav-row .nav-item.is-active .footer-text {
  color: #d4af37;
}

.footer-nav-row .nav-item.is-active .footer-text {
  font-weight: 600;
}
</style>
